import { useCallback, useEffect, useState } from 'react'
import styled from '@emotion/styled'
import {
  selectCurrentItem,
  setCurrentItem,
  closeModal,
  useAppDispatch,
  useAppSelector,
} from '@open-tender/cloud'
import { MenuItem } from '..'

const ItemModalView = styled.div`
  position: relative;
  width: 90%;
  max-width: ${(props) => props.theme.item.desktop.maxWidth};
  height: 90%;
  overflow: hidden;
  background-color: ${(props) => props.theme.bgColors.primary};
  border-radius: ${(props) => props.theme.border.radius};
  @media (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    width: 100%;
    max-width: ${(props) => props.theme.item.mobile.maxWidth};
    height: 100%;
    border-radius: 0;
  }
`

const ItemModalContent = styled.div`
  padding: 0;
  height: 100%;
  overflow: hidden;
`

const ItemModal = () => {
  const dispatch = useAppDispatch()
  const item = useAppSelector(selectCurrentItem)
  const [imageUrl, setImageUrl] = useState(item ? item.imageUrl : null)
  const imageUrlWithFallback = (imageUrl || item?.imageUrl) ?? null

  const cancel = useCallback(() => {
    dispatch(closeModal())
    setTimeout(() => {
      dispatch(setCurrentItem(null))
    }, 275)
  }, [dispatch])

  useEffect(() => {
    if (item?.imageUrl) {
      setImageUrl(item.imageUrl)
    }
  }, [item?.imageUrl])

  if (!item) return null

  return (
    <ItemModalView>
      <ItemModalContent role="dialog" aria-labelledby="dialogTitle">
        <MenuItem
          cancel={cancel}
          imageUrlWithFallback={imageUrlWithFallback}
          setImageUrl={setImageUrl}
        />
      </ItemModalContent>
    </ItemModalView>
  )
}

export default ItemModal
